import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {JSONValue} from 'util/Types';

import {PipelineGraphQL} from './PipelineTypes';

// Keep in sync with UNSET_VARIABLE_VALUE in benchling/pipelines/step_type_library/step_config_shapes.py
export const UNSET_CONFIG_VARIABLE = 'UNSET';

/**
 * Config overrides for output steps added to analysis templates. On templates, certain config fields
 * are set to UNSET_CONFIG_VARIABLE so they can be filled in when the template is applied.
 */
export function getTemplateOutputStepConfig(
  pipeline: Pick<PipelineGraphQL, '__typename'>,
  stepType: PipelineStepType
): Record<string, JSONValue> | undefined {
  if (pipeline.__typename !== 'AnalysisTemplateNode') {
    return undefined;
  }
  switch (stepType) {
    case PipelineStepType.EXPORT_DATA_CATALOG_DATASET:
      return {folderId: UNSET_CONFIG_VARIABLE};
    default:
      return undefined;
  }
}
